import { Link } from "react-router-dom";
import { api, unwrap } from "../../api/client";
import { ErrorMessage, Loading } from "../../components/ui";
import { t } from "../../i18n/t";
import { formatDateTime, formatNumber } from "../../lib/format";
import { routes } from "../../lib/routes";
import { usePageTitle } from "../../lib/usePageTitle";
import { useQuery } from "../../lib/useQuery";
import { useKommune } from "./KommuneContext";

export function ChangesPage() {
  const { orgId, nr, navn } = useKommune();
  usePageTitle(`${t("changes.title")} – ${navn}`);
  const list = useQuery(`changes:${orgId}:${nr}`, (signal) =>
    unwrap(
      api.GET("/api/orgs/{org_id}/kommuner/{nummer}/changes", {
        params: { path: { org_id: orgId, nummer: nr } },
        signal,
      }),
    ),
  );

  return (
    <div className="page">
      <header className="page-header">
        <p className="eyebrow">{navn}</p>
        <h1>{t("changes.title")}</h1>
        <p className="muted">{t("changes.intro")}</p>
      </header>
      {list.error && <ErrorMessage error={list.error} onRetry={list.reload} />}
      {!list.data && !list.error && <Loading />}
      {list.data && list.data.length === 0 && <p>{t("changes.empty")}</p>}
      {list.data && list.data.length > 0 && (
        <div className="table-wrap">
          <table className="data-table">
            <caption className="visually-hidden">{t("changes.caption")}</caption>
            <thead>
              <tr>
                <th scope="col">{t("changes.colDate")}</th>
                <th scope="col" className="num">
                  {t("changes.colNew")}
                </th>
                <th scope="col" className="num">
                  {t("changes.colResolved")}
                </th>
                <th scope="col" className="num">
                  {t("changes.colChanged")}
                </th>
                <th scope="col">{t("changes.colLink")}</th>
              </tr>
            </thead>
            <tbody>
              {list.data.map((c) => {
                const date = formatDateTime(c.created_at);
                return (
                  <tr key={c.id}>
                    <th scope="row">{date}</th>
                    <td className="num">{formatNumber(c.counts.new ?? 0)}</td>
                    <td className="num">{formatNumber(c.counts.resolved ?? 0)}</td>
                    <td className="num">{formatNumber(c.counts.changed ?? 0)}</td>
                    <td>
                      <Link
                        to={routes.change(orgId, nr, c.id)}
                        aria-label={t("changes.detailsLabel", { date })}
                      >
                        {t("changes.details")}
                      </Link>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
